module.exports = __webpack_public_path__ + "img/wechatActive.43c90f14.svg";